import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { IAdLinkTemplate } from '../../../../main/types/links';

const FetchAdLinkTemplate = new ReduxAsyncAction<'FETCH_AD_LINK_TEMPLATE', string, { selectedTemplate: IAdLinkTemplate }>(
  'FETCH_AD_LINK_TEMPLATE'
);

FetchAdLinkTemplate.registerRequest(async (templateId: string): Promise<{ selectedTemplate: IAdLinkTemplate }> => {
  try {
    const { data: selectedTemplate } = await dash_api.get(`/v1/linkhub/ad-link-templates/${templateId}`);

    return { selectedTemplate };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch template.', 'error');

    throw error;
  }
});

export const FETCH_AD_LINK_TEMPLATE = FetchAdLinkTemplate.actionNamespaceConstants;
export const fetchAdLinkTemplate = FetchAdLinkTemplate.request;

export type FetchAdLinkTemplateResponseAction = Action<typeof FETCH_AD_LINK_TEMPLATE.response> & {
  data: { selectedTemplate: IAdLinkTemplate };
};
